// extracted by mini-css-extract-plugin
export default {"wrapper":"Quote_wrapper__6za1C","copy":"Quote_copy__iWy+9"};